__turbopack_context__.v({
  "acts": "home-module__Eu-hOa__acts",
  "addr": "home-module__Eu-hOa__addr",
  "arrow": "home-module__Eu-hOa__arrow",
  "avaDoes": "home-module__Eu-hOa__avaDoes",
  "avoided": "home-module__Eu-hOa__avoided",
  "band": "home-module__Eu-hOa__band",
  "before": "home-module__Eu-hOa__before",
  "blink": "home-module__Eu-hOa__blink",
  "board": "home-module__Eu-hOa__board",
  "btn": "home-module__Eu-hOa__btn",
  "btns": "home-module__Eu-hOa__btns",
  "calm": "home-module__Eu-hOa__calm",
  "caught": "home-module__Eu-hOa__caught",
  "chain": "home-module__Eu-hOa__chain",
  "check": "home-module__Eu-hOa__check",
  "chip": "home-module__Eu-hOa__chip",
  "city": "home-module__Eu-hOa__city",
  "closeGrid": "home-module__Eu-hOa__closeGrid",
  "conn": "home-module__Eu-hOa__conn",
  "copy": "home-module__Eu-hOa__copy",
  "count": "home-module__Eu-hOa__count",
  "ctx": "home-module__Eu-hOa__ctx",
  "cursor": "home-module__Eu-hOa__cursor",
  "date": "home-module__Eu-hOa__date",
  "desk": "home-module__Eu-hOa__desk",
  "deskFoot": "home-module__Eu-hOa__deskFoot",
  "deskHead": "home-module__Eu-hOa__deskHead",
  "doc": "home-module__Eu-hOa__doc",
  "docMeta": "home-module__Eu-hOa__docMeta",
  "docTitle": "home-module__Eu-hOa__docTitle",
  "done": "home-module__Eu-hOa__done",
  "dot": "home-module__Eu-hOa__dot",
  "early": "home-module__Eu-hOa__early",
  "feed": "home-module__Eu-hOa__feed",
  "feedMeta": "home-module__Eu-hOa__feedMeta",
  "feedTitle": "home-module__Eu-hOa__feedTitle",
  "field": "home-module__Eu-hOa__field",
  "fields": "home-module__Eu-hOa__fields",
  "fixed": "home-module__Eu-hOa__fixed",
  "fl": "home-module__Eu-hOa__fl",
  "fld": "home-module__Eu-hOa__fld",
  "flow": "home-module__Eu-hOa__flow",
  "footRow": "home-module__Eu-hOa__footRow",
  "footTop": "home-module__Eu-hOa__footTop",
  "footer": "home-module__Eu-hOa__footer",
  "found": "home-module__Eu-hOa__found",
  "founder": "home-module__Eu-hOa__founder",
  "fs": "home-module__Eu-hOa__fs",
  "fv": "home-module__Eu-hOa__fv",
  "ground": "home-module__Eu-hOa__ground",
  "h2": "home-module__Eu-hOa__h2",
  "head": "home-module__Eu-hOa__head",
  "header": "home-module__Eu-hOa__header",
  "hero": "home-module__Eu-hOa__hero",
  "job": "home-module__Eu-hOa__job",
  "jobFoot": "home-module__Eu-hOa__jobFoot",
  "jobFrom": "home-module__Eu-hOa__jobFrom",
  "jobHead": "home-module__Eu-hOa__jobHead",
  "jobSec": "home-module__Eu-hOa__jobSec",
  "jobStatus": "home-module__Eu-hOa__jobStatus",
  "jobTitle": "home-module__Eu-hOa__jobTitle",
  "kicker": "home-module__Eu-hOa__kicker",
  "lab": "home-module__Eu-hOa__lab",
  "lamp": "home-module__Eu-hOa__lamp",
  "lampGlow": "home-module__Eu-hOa__lampGlow",
  "lede": "home-module__Eu-hOa__lede",
  "legend": "home-module__Eu-hOa__legend",
  "lines": "home-module__Eu-hOa__lines",
  "link": "home-module__Eu-hOa__link",
  "msg": "home-module__Eu-hOa__msg",
  "msgFoot": "home-module__Eu-hOa__msgFoot",
  "msgTop": "home-module__Eu-hOa__msgTop",
  "msgWho": "home-module__Eu-hOa__msgWho",
  "nav": "home-module__Eu-hOa__nav",
  "navlinks": "home-module__Eu-hOa__navlinks",
  "needs": "home-module__Eu-hOa__needs",
  "node": "home-module__Eu-hOa__node",
  "page": "home-module__Eu-hOa__page",
  "pen": "home-module__Eu-hOa__pen",
  "penHalo": "home-module__Eu-hOa__penHalo",
  "pile": "home-module__Eu-hOa__pile",
  "pileHead": "home-module__Eu-hOa__pileHead",
  "pm": "home-module__Eu-hOa__pm",
  "points": "home-module__Eu-hOa__points",
  "prop": "home-module__Eu-hOa__prop",
  "propHead": "home-module__Eu-hOa__propHead",
  "propSub": "home-module__Eu-hOa__propSub",
  "replay": "home-module__Eu-hOa__replay",
  "rise": "home-module__Eu-hOa__rise",
  "roles": "home-module__Eu-hOa__roles",
  "rows": "home-module__Eu-hOa__rows",
  "settle": "home-module__Eu-hOa__settle",
  "sf": "home-module__Eu-hOa__sf",
  "skip": "home-module__Eu-hOa__skip",
  "skyline": "home-module__Eu-hOa__skyline",
  "sm": "home-module__Eu-hOa__sm",
  "sources": "home-module__Eu-hOa__sources",
  "src": "home-module__Eu-hOa__src",
  "srcs": "home-module__Eu-hOa__srcs",
  "stack": "home-module__Eu-hOa__stack",
  "stamp": "home-module__Eu-hOa__stamp",
  "status": "home-module__Eu-hOa__status",
  "step": "home-module__Eu-hOa__step",
  "stepBody": "home-module__Eu-hOa__stepBody",
  "stepTitle": "home-module__Eu-hOa__stepTitle",
  "stroke": "home-module__Eu-hOa__stroke",
  "sub": "home-module__Eu-hOa__sub",
  "tabs": "home-module__Eu-hOa__tabs",
  "trust": "home-module__Eu-hOa__trust",
  "try": "home-module__Eu-hOa__try",
  "verify": "home-module__Eu-hOa__verify",
  "vis": "home-module__Eu-hOa__vis",
  "visReceipt": "home-module__Eu-hOa__visReceipt",
  "visTime": "home-module__Eu-hOa__visTime",
  "vt": "home-module__Eu-hOa__vt",
  "watch": "home-module__Eu-hOa__watch",
  "what": "home-module__Eu-hOa__what",
  "when": "home-module__Eu-hOa__when",
  "who": "home-module__Eu-hOa__who",
  "win": "home-module__Eu-hOa__win",
  "winWho": "home-module__Eu-hOa__winWho",
  "wins": "home-module__Eu-hOa__wins",
  "work": "home-module__Eu-hOa__work",
  "wrap": "home-module__Eu-hOa__wrap",
});
